import { render, staticRenderFns } from "./AddOutgoing.vue?vue&type=template&id=b61565e6&"
import script from "./AddOutgoing.vue?vue&type=script&lang=js&"
export * from "./AddOutgoing.vue?vue&type=script&lang=js&"
import style0 from "./AddOutgoing.vue?vue&type=style&index=0&id=b61565e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports